import { StyleSheet, View } from "@react-pdf/renderer";

import { CustomRiskLevel, RiskLevelColorMap } from "src/core/constants/risk";

const styles = StyleSheet.create({
  riskDot: {
    width: 14,
    height: 14,
    borderRadius: 8,
  },
});

type RiskDotProps = {
  riskLevel: CustomRiskLevel;
};

export const RiskDot = ({ riskLevel }: RiskDotProps) => {
  const riskColor = RiskLevelColorMap[riskLevel];

  return <View style={[styles.riskDot, { backgroundColor: riskColor }]} />;
};
